import { useState } from 'react'
import { Facet, BooleanFacetValue } from './Types'
import Clickable from 'components/clickable'
import { Checkbox } from 'components/forms'

interface BooleanFacetProps {
  facet: Facet<BooleanFacetValue>
  onChange: (selectedOptions: boolean) => void
  initialValue: boolean
}

export const BooleanFacet = ({
  facet,
  onChange,
  initialValue = false,
}: BooleanFacetProps) => {
  const [checked, setChecked] = useState(initialValue)
  const trueObject = Array.isArray(facet.values)
    ? facet.values.find((value) => value.true !== undefined)
    : undefined
  const count = trueObject ? trueObject.true : 0

  const handleClick = () => {
    const newChecked = !checked
    setChecked(newChecked)
    onChange(newChecked)
  }
  return (
    // @ts-ignore
    <Clickable className="phxl" onClick={handleClick} style={{ width: '100%' }}>
      <div className="flex align-center">
        <div
          className="h7 flex grow text-uppercase text-bold text-light"
          style={{ fontSize: 12 }}
        >{`${facet.label} (${count})`}</div>
        <Checkbox
          checked={checked}
          className="man"
          groupClassName="man pan"
          value="1"
          size="large"
          style={{
            pointerEvents: 'none',
          }}
        />
      </div>
    </Clickable>
  )
}
